import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { blogPosts } from '../../data/mock';

const Blog = () => {
  return (
    <section id="blog" className="section" style={{ background: '#FFFFFF' }}>
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-2 w-2 rounded-full" style={{ background: '#2EF5FF' }} />
              <span className="text-xs md:text-sm uppercase tracking-[0.25em] font-medium text-[#12367F]/70">
                Our Blog
              </span>
            </div>
            <h2 className="font-display uppercase text-[#12367F] text-balance max-w-3xl" style={{ fontSize: 'clamp(2.25rem, 5.5vw, 5rem)', lineHeight: 0.92 }}>
              The latest industry insights{' '}
              <span style={{ background: '#2EF5FF' }} className="px-2 rounded-md">and deep dives</span>{' '}
              from Nasu Group
            </h2>
          </div>
          <Link to="/blog" className="btn-base btn-outline-dark self-start md:self-end">
            To the blog <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {blogPosts.slice(0, 3).map((p) => (
            <Link key={p.id} to={`/blog/${p.id}`} className="work-card group block">
              <div className="relative rounded-3xl overflow-hidden aspect-[4/3] bg-[#12367F]/10">
                <img src={p.image} alt={p.title} loading="lazy" className="work-img absolute inset-0 w-full h-full object-cover" />
                <span className="absolute top-4 left-4 text-xs uppercase tracking-wider px-3 py-1 rounded-full bg-white/95 text-[#12367F] font-medium">
                  {p.category}
                </span>
              </div>
              <div className="pt-5">
                <p className="text-xs uppercase tracking-wider text-[#12367F]/60">{p.readTime}</p>
                <p className="mt-2 font-display uppercase text-[#12367F] text-2xl md:text-3xl leading-none">{p.title}</p>
                <p className="mt-3 text-[#12367F]/75 text-sm leading-relaxed">{p.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;
